import { PatientStackParamList } from '@/navigations/PatientStack';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useEffect, useRef } from 'react';
import { AppState, AppStateStatus } from 'react-native';
import { IS_ANDROID, IS_WEB } from '@/utils/platform';

export const usePrivacy = (isAuthenticated: boolean) => {
  const currentAppState = useRef(AppState.currentState);
  const navigation =
    useNavigation<StackNavigationProp<PatientStackParamList>>();

  const handleOnAppBlur = () => {
    navigation.navigate('Privacy');
  };

  const handleOnAppFocus = () => {
    // Ticket: RAA-1826
    // This is causing a bug on Android devices where it is navigating back twice.
    // Adding this conditional prevents the double navigation.
    if (!IS_ANDROID) {
      navigation.canGoBack() && navigation.goBack();
    }
  };

  const handleAppStateChange = (nextState: AppStateStatus) => {
    if (!isAuthenticated || IS_WEB) {
      return;
    }

    const notActive = nextState === 'inactive' || nextState === 'background';

    if (notActive) {
      handleOnAppBlur();
    } else {
      handleOnAppFocus();
    }
    currentAppState.current = nextState;
  };

  useEffect(() => {
    const subscription = AppState.addEventListener(
      'change',
      handleAppStateChange,
    );

    return () => {
      subscription.remove();
    };
  }, []);
};
